<template>
  <div class="space-y-6">
    <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-2">Perfil da pessoa *</label>
        <div class="grid grid-cols-1 sm:grid-cols-4 gap-3">
          <label class="flex items-center space-x-2 p-3 border border-gray-200 rounded-lg hover:border-indigo-300 transition cursor-pointer">
            <input v-model="form.owner" type="checkbox" class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-2 focus:ring-indigo-500" />
            <span class="text-sm font-medium text-gray-700">Proprietário</span>
          </label>
          <label class="flex items-center space-x-2 p-3 border border-gray-200 rounded-lg hover:border-indigo-300 transition cursor-pointer">
            <input v-model="form.customer" type="checkbox" class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-2 focus:ring-indigo-500" />
            <span class="text-sm font-medium text-gray-700">Cliente</span>
          </label>
          <label class="flex items-center space-x-2 p-3 border border-gray-200 rounded-lg hover:border-indigo-300 transition cursor-pointer">
            <input v-model="form.agent" type="checkbox" class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-2 focus:ring-indigo-500" />
            <span class="text-sm font-medium text-gray-700">Corretor</span>
          </label>
          <label class="flex items-center space-x-2 p-3 border border-gray-200 rounded-lg hover:border-indigo-300 transition cursor-pointer">
            <input v-model="form.provider" type="checkbox" class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-2 focus:ring-indigo-500" />
            <span class="text-sm font-medium text-gray-700">Prestador Serviço</span>
          </label>
        </div>
      </div>

    <!-- Seção de Informações Pessoais -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Nome *</label>
        <input
          v-model="form.name"
          type="text"
          required
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">E-mail</label>
        <input
          v-model="form.email"
          type="email"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <div class="flex items-center justify-between mb-1">
          <label class="block text-sm font-medium text-gray-700">Telefone</label>
          <a
            v-if="phoneWhatsAppLink(form.phone)"
            :href="phoneWhatsAppLink(form.phone)"
            target="_blank"
            rel="noopener"
            class="text-gray-400 hover:text-emerald-600 transition"
            title="Abrir no WhatsApp"
          >
            <i class="fab fa-whatsapp text-lg"></i>
          </a>
        </div>
        <input
          v-model="form.phone"
          @input="applyPhoneMask"
          type="tel"
          placeholder="(00) 00000-0000"
          maxlength="15"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        <p class="text-xs text-gray-500 mt-1">Obrigatório informar telefone ou CPF/CNPJ</p>
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">CPF/CNPJ</label>
        <input
          v-model="form.document"
          @input="applyDocumentMask"
          type="text"
          maxlength="18"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">RG</label>
        <input
          v-model="form.rg"
          @input="applyRgMask"
          type="text"
          maxlength="12"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Profissão</label>
        <input
          v-model="form.profession"
          type="text"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Estado Civil</label>
        <select
          v-model="form.marital_status"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="">Selecione</option>
          <option value="Solteiro(a)">Solteiro(a)</option>
          <option value="Casado(a)">Casado(a)</option>
          <option value="Divorciado(a)">Divorciado(a)</option>
          <option value="Viúvo(a)">Viúvo(a)</option>
        </select>
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Nacionalidade</label>
        <input
          v-model="form.nationality"
          type="text"
          placeholder="Ex: brasileiro(a)"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">CEP</label>
        <input
          ref="zipInput"
          v-model="form.zip"
          @input="fetchAddressByCep"
          type="text"
          placeholder="00000-000"
          maxlength="9"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Endereço</label>
        <input
          ref="addressInput"
          v-model="form.address"
          type="text"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Número</label>
        <input
          v-model="form.number"
          type="text"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Bairro</label>
        <input
          ref="neighborhoodInput"
          v-model="form.neighborhood"
          type="text"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
        <CitySelectAsync
          v-model="form.city_id"
          :selected-label="form.city_label || ''"
          label=""
          placeholder="Digite para buscar cidade..."
          @city-picked="onCityPicked"
        />
      </div>

      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Observações</label>
        <textarea
          v-model="form.note"
          rows="3"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        ></textarea>
      </div>

      <div class="md:col-span-2">
        <label class="flex items-center space-x-3 p-4 border-2 border-gray-200 rounded-lg hover:border-indigo-300 transition cursor-pointer group">
          <input
            v-model="form.blocked"
            type="checkbox"
            class="w-5 h-5 text-red-600 border-gray-300 rounded focus:ring-2 focus:ring-red-500 cursor-pointer"
          />
          <div class="flex-1">
            <span class="text-sm font-semibold text-gray-900">{{ blockLabel }}</span>
            <p class="text-xs text-gray-500 mt-0.5">Esta pessoa não poderá ser selecionada em novas operações</p>
          </div>
          <svg class="w-5 h-5 text-red-500 opacity-0 group-hover:opacity-100 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </label>
      </div>
    </div>

    <!-- Locador: rubrica e assinatura (final do formulário) -->
    <div
      v-if="form.owner"
      class="rounded-lg border border-indigo-200 bg-indigo-50/50 p-4 space-y-4"
    >
      <div>
        <h3 class="text-sm font-semibold text-gray-900">
          Rubrica e assinatura para geração do contrato (locador)
        </h3>
        <p class="text-xs text-gray-600 mt-1 leading-relaxed">
          Cadastre a rúbrica e a assinatura do proprietário para geração do contrato. Pode gerar o link e enviar ao proprietário para desenhar.
        </p>
      </div>

      <div
        v-if="form.id"
        class="rounded-md border border-indigo-100 bg-white/90 p-3 space-y-3"
      >
        <p class="text-xs font-medium text-gray-700">Link para o proprietário criar a rúbrica e a assinatura</p>
        <template v-if="ownerDrawLinkDisplayUrl">
          <p v-if="ownerDrawExpiresLabel" class="text-xs text-gray-500">
            Válido até {{ ownerDrawExpiresLabel }}
          </p>
          <div class="flex flex-col sm:flex-row gap-2">
            <input
              type="text"
              readonly
              :value="ownerDrawLinkDisplayUrl"
              class="flex-1 min-w-0 text-xs border border-gray-200 rounded-lg px-2 py-2 bg-gray-50 text-gray-800"
            />
            <div class="flex flex-wrap gap-2 shrink-0">
              <button
                type="button"
                class="px-3 py-2 text-xs font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition shadow-sm"
                @click="copyOwnerDrawLink"
              >
                {{ ownerDrawLinkCopied ? 'Copiado!' : 'Copiar' }}
              </button>
              <button
                type="button"
                class="inline-flex items-center justify-center gap-1.5 px-3 py-2 text-xs font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 transition shadow-sm"
                title="Abre o WhatsApp com a mensagem e o link. Se não houver celular válido no cadastro, você escolhe o contato."
                @click="shareOwnerDrawViaWhatsApp"
              >
                <i class="fab fa-whatsapp text-base" aria-hidden="true"></i>
                WhatsApp
              </button>
            </div>
          </div>
          <button
            type="button"
            class="text-xs text-indigo-600 hover:text-indigo-800 font-medium"
            :disabled="ownerDrawGenerating"
            @click="createOwnerDrawLink"
          >
            {{ ownerDrawGenerating ? 'Gerando…' : 'Gerar novo link (o anterior deixa de valer)' }}
          </button>
        </template>
        <template v-else>
          <p
            v-if="form.owner_contract_draw_link_expired && form.owner_contract_draw_token_present"
            class="text-xs text-amber-800"
          >
            O link enviado anteriormente expirou. Gere um novo e envie de novo ao proprietário.
          </p>
          <button
            type="button"
            class="w-full sm:w-auto px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 disabled:opacity-50"
            :disabled="ownerDrawGenerating"
            @click="createOwnerDrawLink"
          >
            {{
              ownerDrawGenerating
                ? 'Gerando…'
                : (form.owner_contract_draw_link_expired && form.owner_contract_draw_token_present
                  ? 'Gerar novo link'
                  : 'Gerar link para o proprietário')
            }}
          </button>
        </template>
      </div>
      <p v-else class="text-xs text-amber-800">
        Salve o cadastro da pessoa antes de gerar o link para o proprietário.
      </p>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div class="flex items-center justify-between mb-1">
            <label class="text-sm font-medium text-gray-700">Rubrica</label>
            <button
              type="button"
              class="text-xs text-indigo-600 hover:text-indigo-800"
              @click="clearOwnerRubrica"
            >
              Limpar
            </button>
          </div>
          <canvas
            ref="ownerRubricaCanvas"
            class="w-full max-w-md touch-none border-2 border-gray-300 rounded-lg bg-white cursor-crosshair h-36"
            @pointerdown.prevent="onOwnerPointerDown($event, 'rubrica')"
            @pointermove.prevent="onOwnerPointerMove($event, 'rubrica')"
            @pointerup.prevent="onOwnerPointerUp($event, 'rubrica')"
            @pointerleave.prevent="onOwnerPointerUp($event, 'rubrica')"
          />
        </div>
        <div>
          <div class="flex items-center justify-between mb-1">
            <label class="text-sm font-medium text-gray-700">Assinatura</label>
            <button
              type="button"
              class="text-xs text-indigo-600 hover:text-indigo-800"
              @click="clearOwnerAssinatura"
            >
              Limpar
            </button>
          </div>
          <canvas
            ref="ownerAssinaturaCanvas"
            class="w-full max-w-md touch-none border-2 border-gray-300 rounded-lg bg-white cursor-crosshair h-36"
            @pointerdown.prevent="onOwnerPointerDown($event, 'assinatura')"
            @pointermove.prevent="onOwnerPointerMove($event, 'assinatura')"
            @pointerup.prevent="onOwnerPointerUp($event, 'assinatura')"
            @pointerleave.prevent="onOwnerPointerUp($event, 'assinatura')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { openWhatsAppShare, buildWhatsAppMessageWithLink } from '../composables/useWhatsAppShare.js'
import { useBrazilianMasks } from '../composables/useBrazilianMasks.js'
import { useViaCep } from '../composables/useViaCep.js'
import { useApi } from '../composables/useApi.js'
import CitySelectAsync from './CitySelectAsync.vue'

const { getWhatsAppLink, handlePhoneInput, handleDocumentInput, handleCpfInput, handleRgInput } = useBrazilianMasks()
const { handleCepLookup } = useViaCep()

export default {
  components: {
    CitySelectAsync
  },

  props: {
    form: {
      type: Object,
      required: true
    },
    blockLabel: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      ownerDrawLinkCopied: false,
      ownerDrawGenerating: false,
      ownerDrawState: {
        rubrica: { active: false, ctx: null, dpr: 1, hasInk: false },
        assinatura: { active: false, ctx: null, dpr: 1, hasInk: false }
      },
      _ownerCanvasResizeObserver: null
    }
  },

  computed: {
    ownerDrawLinkDisplayUrl() {
      return this.form.owner_contract_draw_url || ''
    },
    ownerDrawExpiresLabel() {
      const raw = this.form.owner_contract_draw_expires_at
      if (!raw) return ''
      const d = new Date(raw)
      if (Number.isNaN(d.getTime())) return ''
      return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })
    }
  },

  watch: {
    'form.owner'(isOwner) {
      if (!isOwner) {
        this.form.contract_owner_rubric = null
        this.form.contract_owner_signature = null
        this.teardownOwnerContractCanvases()
      } else {
        this.scheduleOwnerCanvasInit()
      }
    },
    'form.id'() {
      if (this.form.owner) this.scheduleOwnerCanvasInit()
    }
  },

  mounted() {
    if (this.form.owner) this.scheduleOwnerCanvasInit()
  },

  beforeUnmount() {
    this.teardownOwnerContractCanvases()
  },

  methods: {
    async createOwnerDrawLink() {
      if (!this.form.id) return
      this.ownerDrawGenerating = true
      try {
        const { post } = useApi()
        const { data, error } = await post(`/api/v1/people/${this.form.id}/owner_contract_draw_link`, {})
        if (error) {
          const list = error.response?.data?.errors
          const msg = Array.isArray(list) ? list.join(', ') : (error.message || 'Não foi possível gerar o link.')
          if (this.$toast && this.$toast.error) this.$toast.error(msg)
          else window.alert(msg)
          return
        }
        this.form.owner_contract_draw_url = data.owner_contract_draw_url
        this.form.owner_contract_draw_expires_at = data.owner_contract_draw_expires_at
        this.form.owner_contract_draw_link_expired = false
        this.form.owner_contract_draw_token_present = true
        if (this.$toast && this.$toast.success) this.$toast.success('Link gerado.')
      } finally {
        this.ownerDrawGenerating = false
      }
    },

    async copyOwnerDrawLink() {
      const url = this.ownerDrawLinkDisplayUrl
      if (!url) return

      try {
        await navigator.clipboard.writeText(url)
        this.ownerDrawLinkCopied = true
        window.setTimeout(() => {
          this.ownerDrawLinkCopied = false
        }, 2000)
      } catch (e) {
        const input = document.createElement('input')
        input.value = url
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.ownerDrawLinkCopied = true
        window.setTimeout(() => {
          this.ownerDrawLinkCopied = false
        }, 2000)
      }
    },

    shareOwnerDrawViaWhatsApp() {
      const url = this.ownerDrawLinkDisplayUrl
      if (!url) return
      const text = buildWhatsAppMessageWithLink(
        'Segue o link para você criar sua rubrica e assinatura. Clique abaixo e siga as instruções!',
        url
      )
      openWhatsAppShare(this.form.phone, text)
    },

    scheduleOwnerCanvasInit() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.initOwnerContractCanvases())
        })
      })
    },

    teardownOwnerContractCanvases() {
      if (this._ownerCanvasResizeObserver) {
        this._ownerCanvasResizeObserver.disconnect()
        this._ownerCanvasResizeObserver = null
      }
      this.ownerDrawState.rubrica = { active: false, ctx: null, dpr: 1, hasInk: false }
      this.ownerDrawState.assinatura = { active: false, ctx: null, dpr: 1, hasInk: false }
    },

    initOwnerContractCanvases() {
      if (!this.form.owner) return
      ;[ 'ownerRubricaCanvas', 'ownerAssinaturaCanvas' ].forEach((refName, idx) => {
        const el = this.$refs[refName]
        if (!el || typeof el.getContext !== 'function') return
        const key = idx === 0 ? 'rubrica' : 'assinatura'
        this.setupOwnerCanvas(el, key)
      })
      this.bindOwnerCanvasResizeObservers()
      requestAnimationFrame(() => {
        requestAnimationFrame(() => void this.paintSavedOwnerContractImages())
      })
    },

    bindOwnerCanvasResizeObservers() {
      this.unbindOwnerCanvasResizeObservers()
      if (typeof ResizeObserver === 'undefined' || !this.form.owner) return
      const ro = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          const rub = this.$refs.ownerRubricaCanvas
          const ass = this.$refs.ownerAssinaturaCanvas
          if (rub && this.ownerCanvasNeedsRelayout(rub)) {
            this.setupOwnerCanvas(rub, 'rubrica')
            void this.paintSavedImageForKey('rubrica')
          }
          if (ass && this.ownerCanvasNeedsRelayout(ass)) {
            this.setupOwnerCanvas(ass, 'assinatura')
            void this.paintSavedImageForKey('assinatura')
          }
        })
      })
      const rub = this.$refs.ownerRubricaCanvas
      const ass = this.$refs.ownerAssinaturaCanvas
      if (rub) ro.observe(rub)
      if (ass) ro.observe(ass)
      this._ownerCanvasResizeObserver = ro
    },

    unbindOwnerCanvasResizeObservers() {
      if (this._ownerCanvasResizeObserver) {
        this._ownerCanvasResizeObserver.disconnect()
        this._ownerCanvasResizeObserver = null
      }
    },

    ownerCanvasNeedsRelayout(canvas) {
      const dpr = window.devicePixelRatio || 1
      const cw = Math.max(1, canvas.clientWidth)
      const ch = Math.max(1, canvas.clientHeight)
      const w = Math.floor(cw * dpr)
      const h = Math.floor(ch * dpr)
      return canvas.width !== w || canvas.height !== h
    },

    setupOwnerCanvas(canvas, key) {
      const cw = Math.max(1, canvas.clientWidth)
      const ch = Math.max(1, canvas.clientHeight)
      const dpr = window.devicePixelRatio || 1
      canvas.width = Math.floor(cw * dpr)
      canvas.height = Math.floor(ch * dpr)
      const ctx = canvas.getContext('2d')
      ctx.setTransform(1, 0, 0, 1, 0, 0)
      ctx.scale(dpr, dpr)
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, cw, ch)
      ctx.strokeStyle = '#111827'
      ctx.lineWidth = 2
      ctx.lineCap = 'round'
      ctx.lineJoin = 'round'
      this.ownerDrawState[key].ctx = ctx
      this.ownerDrawState[key].dpr = dpr
      this.ownerDrawState[key].hasInk = false
    },

    absoluteAssetUrl(u) {
      if (!u) return ''
      const s = String(u)
      if (s.startsWith('http://') || s.startsWith('https://')) return s
      if (s.startsWith('//')) return `${window.location.protocol}${s}`
      if (s.startsWith('/')) return `${window.location.origin}${s}`
      return s
    },

    loadImageElement(src) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = () => reject(new Error('image load failed'))
        img.src = src
      })
    },

    async paintSavedImageForKey(key) {
      const raw = key === 'rubrica' ? this.form.contract_owner_rubric_url : this.form.contract_owner_signature_url
      const href = this.absoluteAssetUrl(raw)
      if (!href) return

      const canvas = key === 'rubrica' ? this.$refs.ownerRubricaCanvas : this.$refs.ownerAssinaturaCanvas
      const st = this.ownerDrawState[key]
      if (!canvas || !st.ctx) return

      let objUrl = null
      try {
        const res = await fetch(href, { credentials: 'include' })
        if (!res.ok) return
        const blob = await res.blob()
        if (!blob || blob.size < 50) return
        objUrl = URL.createObjectURL(blob)
        const img = await this.loadImageElement(objUrl)
        const cw = Math.max(1, canvas.clientWidth)
        const ch = Math.max(1, canvas.clientHeight)
        const ctx = st.ctx
        const iw = img.naturalWidth
        const ih = img.naturalHeight
        if (iw <= 0 || ih <= 0) return

        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0, 0, cw, ch)

        const scale = Math.min(cw / iw, ch / ih)
        const dw = iw * scale
        const dh = ih * scale
        const ox = (cw - dw) / 2
        const oy = (ch - dh) / 2
        ctx.drawImage(img, ox, oy, dw, dh)

        ctx.strokeStyle = '#111827'
        ctx.lineWidth = 2
        ctx.lineCap = 'round'
        ctx.lineJoin = 'round'
        st.hasInk = true
      } catch (e) {
        /* rede / CORS / tipo inválido: mantém canvas em branco */
      } finally {
        if (objUrl) URL.revokeObjectURL(objUrl)
      }
    },

    async paintSavedOwnerContractImages() {
      if (!this.form.owner) return
      await Promise.all([
        this.paintSavedImageForKey('rubrica'),
        this.paintSavedImageForKey('assinatura')
      ])
    },

    ownerCanvasPoint(canvas, evt) {
      if (evt.currentTarget === canvas && typeof evt.offsetX === 'number' && typeof evt.offsetY === 'number') {
        return { x: evt.offsetX, y: evt.offsetY }
      }
      const rect = canvas.getBoundingClientRect()
      const cw = canvas.clientWidth || rect.width
      const ch = canvas.clientHeight || rect.height
      return {
        x: ((evt.clientX - rect.left) / rect.width) * cw,
        y: ((evt.clientY - rect.top) / rect.height) * ch
      }
    },

    onOwnerPointerDown(evt, key) {
      const canvas = key === 'rubrica' ? this.$refs.ownerRubricaCanvas : this.$refs.ownerAssinaturaCanvas
      if (!canvas) return
      try {
        evt.target.setPointerCapture(evt.pointerId)
      } catch (e) {
        /* ignore */
      }
      const st = this.ownerDrawState[key]
      st.active = true
      if (!st.ctx || this.ownerCanvasNeedsRelayout(canvas)) this.setupOwnerCanvas(canvas, key)
      const p = this.ownerCanvasPoint(canvas, evt)
      st.ctx.beginPath()
      st.ctx.moveTo(p.x, p.y)
    },

    onOwnerPointerMove(evt, key) {
      const st = this.ownerDrawState[key]
      if (!st.active) return
      const canvas = key === 'rubrica' ? this.$refs.ownerRubricaCanvas : this.$refs.ownerAssinaturaCanvas
      if (!canvas || !st.ctx) return
      const p = this.ownerCanvasPoint(canvas, evt)
      st.ctx.lineTo(p.x, p.y)
      st.ctx.stroke()
      st.hasInk = true
    },

    onOwnerPointerUp(evt, key) {
      const st = this.ownerDrawState[key]
      st.active = false
      try {
        evt.target.releasePointerCapture(evt.pointerId)
      } catch (e) {
        /* ignore */
      }
    },

    clearOwnerRubrica() {
      const canvas = this.$refs.ownerRubricaCanvas
      if (canvas) this.setupOwnerCanvas(canvas, 'rubrica')
    },

    clearOwnerAssinatura() {
      const canvas = this.$refs.ownerAssinaturaCanvas
      if (canvas) this.setupOwnerCanvas(canvas, 'assinatura')
    },

    ownerCanvasToPngBlob(canvas) {
      return new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), 'image/png', 0.92)
      })
    },

    async flushOwnerContractSignatures() {
      if (!this.form.owner) return
      const rub = this.$refs.ownerRubricaCanvas
      const ass = this.$refs.ownerAssinaturaCanvas
      if (!rub || !ass) return
      const stR = this.ownerDrawState.rubrica
      const stA = this.ownerDrawState.assinatura
      if (!stR.hasInk || !stA.hasInk) return

      const rubBlob = await this.ownerCanvasToPngBlob(rub)
      const assBlob = await this.ownerCanvasToPngBlob(ass)
      if (!rubBlob || !assBlob || rubBlob.size < 200 || assBlob.size < 200) return

      this.form.contract_owner_rubric = new File([ rubBlob ], 'rubrica-locador.png', { type: 'image/png' })
      this.form.contract_owner_signature = new File([ assBlob ], 'assinatura-locador.png', { type: 'image/png' })
    },

    fetchAddressByCep(event) {
      this.resolveAddressFromCep(event)
    },

    stripAccents(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    },

    async resolveAddressFromCep(event) {
      const addressData = await handleCepLookup(event, this.$refs, this.form)
      if (!addressData?.city || !addressData?.state) return

      const nameNoAccent = this.stripAccents(addressData.city).trim()
      const uf = String(addressData.state || '').trim().toUpperCase()
      if (!nameNoAccent || uf.length !== 2) return

      const params = new URLSearchParams({ q: nameNoAccent.slice(0, 40) })
      params.set('uf', uf)

      const res = await fetch(`/api/v1/cities/search?${params.toString()}`)
      if (!res.ok) return
      const payload = await res.json()
      const list = payload.cities || []
      if (!list.length) return

      const c = list[0]
      const fullLabel =
        c.label ||
        (c.uf ? `${c.display_name || c.name} - ${c.uf}` : c.display_name || c.name)
      this.form.city_id = c.id
      this.form.city_label = fullLabel
    },

    onCityPicked({ label }) {
      this.form.city_label = label || ''
    },

    applyPhoneMask(event) {
      handlePhoneInput(event, this.form)
    },

    applyDocumentMask(event) {
      handleDocumentInput(event, this.form)
    },

    applyCpfMask(event) {
      handleCpfInput(event, this.form)
    },

    applyRgMask(event) {
      handleRgInput(event, this.form)
    },

    phoneWhatsAppLink(phone) {
      return getWhatsAppLink(phone)
    }
  }
}
</script>
